import Heading from 'LuxKit/Typography/Heading'
import React, { useMemo } from 'react'
import qs from 'qs'
import { TourV2TrendingDestination } from './TourV2TrendingLocationsList'
import styled from 'styled-components'
import TrendingDestinationsTile from 'home/components/TrendingDestinations/TrendingDestinationTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import FullWidthCarousel from 'LuxKit/Carousel/FullWidthCarousel'
import CardCarousel from 'LuxKit/Carousel/CardCarousel'
import Group from 'components/utils/Group'

const GridContainer = styled(FullWidthCarousel)`
  > div {
    grid-template-rows: 1fr 1fr 1fr;

    ${mediaQueryUp.tablet} {
      grid-template-rows: unset;
    }
  }
`

const GridContainerCarousel = styled(CardCarousel)`
  > div > div {
    grid-template-rows: 1fr 1fr 1fr;

    ${mediaQueryUp.tablet} {
      grid-template-rows: unset;
    }
  }
`

interface Props {
  locations: Array<TourV2TrendingDestination>
  fullWidthOverflow?: boolean
  title?: React.ReactNode
}

function TourV2TrendingDestinationsCarousel(props: Props) {
  const { locations, fullWidthOverflow = true, title } = props
  const trendingDestinations = useMemo(() => {
    return locations.map((location) => ({
      name: location.destinationName,
      imageId: location.imageId,
      destinationId: location.placeId,
      url: `/search/tours?${qs.stringify({
          destinationId: location.placeId,
          destinationName: location.destinationName,
        })}`,
    }))
  }, [locations])

  return <Group direction="vertical" gap={32}>
    {fullWidthOverflow && <>
      <LayoutContainer>
        <Heading variant="heading2">
          {title ?? <>Immerse yourself in trending <i>destinations</i></>}
        </Heading>
      </LayoutContainer>
      <GridContainer snap="start" gap={12}>
        {
          trendingDestinations.map((trendingDestination, index) => {
            return (
              <TrendingDestinationsTile
                key={trendingDestination.name}
                trendingDestination={trendingDestination}
                index={index}
              />
            )
          })
        }
      </GridContainer>
    </>}
    {!fullWidthOverflow && <>
      <Heading variant="heading2">
        Immerse yourself in trending <i>destinations</i>
      </Heading>
      <GridContainerCarousel gap={12} arrowsOnlyOnHover>
        {trendingDestinations.map((trendingDestination, index) => {
          return (
            <TrendingDestinationsTile
              key={trendingDestination.name}
              trendingDestination={trendingDestination}
              index={index}
            />
          )
        })}
      </GridContainerCarousel>
    </>}
  </Group>
}

export default TourV2TrendingDestinationsCarousel
